import { mixpanel, getMixpanelSubscriptionStatus, getQueueProductsCount } from 'common/helpers'


const mixpanelMiddleware = () => (store) => (next) => (action) => {
  const { rootType, payload } = action

  const { models: { subscription: { status }, queue: { items: oldItems } } } = store.getState()

  const result = next(action)

  if (
    rootType === 'models.subscription.update'
    && payload.status
    && payload.status !== status
  ) {
    mixpanel.register({
      'Subscription Status': getMixpanelSubscriptionStatus(payload.status),
    })
  }

  if (
    rootType === 'models.queue.setItems'
    || rootType === 'models.queue.addItem'
  ) {
    const { count: queueItemsOldCount } = getQueueProductsCount(oldItems)

    // store is new here
    const { models: { queue: { items: newItems } } } = store.getState()
    const { count: queueItemsNewCount } = getQueueProductsCount(newItems)

    if (queueItemsNewCount !==  queueItemsOldCount) {
      mixpanel.register({
        'Products in Queue': queueItemsNewCount,
      })
    }
  }

  return result
}


export default mixpanelMiddleware
